import { createSlice } from '@reduxjs/toolkit';
import { IInitialSitesDetailsState } from './types';

const SLICE_NAME = 'SITES_DETAILS_SLICE';

export const initialState: IInitialSitesDetailsState = {
  loading: false,
  error: '',
  data: {
    sitesCount: 0,
    openIssues: 0,
    issuesResolved: 0,
    newUserReportedIssues: 0,
  },
};

const sitesDetailsSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialState,
  reducers: {
    fetchSitesDetailsError: (state) => {
      state.loading = false;
      state.error = 'error';
    },
    fetchSitesDetails: (state) => {
      state.loading = true;
      state.error = '';
    },
    fetchSitesDetailsSuccess: (state, { payload }) => {
      state.loading = false;
      state.data = payload;
    },
  },
});

export default sitesDetailsSlice;
